import { AdvancedSearchOptions } from 'src/app/models';

export const DEFAULT_CUSTOMER_SEARCH_OPTIONS: AdvancedSearchOptions = {
    CustomerCustId: true,
    CustomerAccountNo: false,
    CustomerName: true,
    CustomerAddress: true,
    CustomerEmail: false,
    CustomerPhone: false,
    LocName: false,
    LocAddress: false,
    IncludeInactive: false,
    IncludeTempCustomers: false,
    SearchFor: ""
};